import 'css-chunksrc/client/scenes/projectStrategicAxes/styles.scss';export default {
  "projectStrategicAxes": "_projectStrategicAxes_13oe7_1",
  "modal": "_modal_13oe7_6",
  "header": "_header_13oe7_10",
  "label": "_label_13oe7_15",
  "operator": "_operator_13oe7_25",
  "main": "_main_13oe7_29",
  "footer": "_footer_13oe7_33",
  "footerTitle": "_footerTitle_13oe7_41",
  "icon": "_icon_13oe7_51"
};